
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from '../pages/home/components/Footer';
import WhatsAppButton from '../pages/home/components/WhatsAppButton';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
